import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (

    <>
        <Helmet>
            <title>Privacy Policy | Freelity</title>
            <meta
                name="description"
                content="Read our privacy policy to understand how Freelity collects, uses, and protects your personal information."
            />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://freelity.com/privacy-policy" />
        </Helmet>

        <section className="sec-free-tools termsconditions">
            <div className="container">
                
                <h1 className="text-center">🔒 Privacy Policy</h1>
                <p><strong>Last Updated:</strong> May 16, 2025</p>

                <h4>1. Who We Are</h4>
                <p>
                    Freelity.com is a free online tools platform that offers utilities for text formatting, image conversion, code editing, and other everyday digital tasks. Our tools are accessible without the need to sign up, and we do not require any login to use them.
                </p>

                <h4>2. Information We Collect</h4>
                <p>We do <strong>not</strong> collect any personally identifiable information (PII) such as your name, email, phone number, or address.</p>
                <p>However, we may collect limited non-personal data to improve your experience:</p>
                <ul>
                    <li>Browser and Device Information</li>
                    <li>IP Address (used temporarily for analytics or security)</li>
                    <li>Cookies (to enhance functionality and user experience)</li>
                </ul>

                <h4>3. How We Use Information</h4>
                <ul>
                    <li>To improve website performance and features</li>
                    <li>To analyze usage trends</li>
                    <li>To ensure website security and prevent abuse</li>
                </ul>

                <h4>4. Cookies</h4>
                <p>
                    Cookies are small data files stored in your browser. We use cookies to enhance your experience, remember preferences, and track anonymous usage data. You can control cookies through your browser settings.
                </p>

                <h4>5. Third-Party Services</h4>
                <p>
                    Our website may include links or content from third-party services (like ads or analytics). We are not responsible for their privacy practices.
                </p>

                <h4>6. Data Sharing</h4>
                <p>
                    We do <strong>not</strong> sell, trade, or share your personal data. We may disclose data only if required by law or to protect the rights of our website.
                </p>

                <h4>7. Children's Privacy</h4>
                <p>
                    Freelity.com is not intended for children under 13. We do not knowingly collect personal data from children.
                </p>

                <h4>8. Changes to This Policy</h4>
                <p>
                    We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised date.
                </p>

                <h4>9. Contact Us</h4>
                <p>
                    If you have any questions or concerns about this Privacy Policy, feel free to contact us at:
                    📧 <strong>support@freelity.com</strong>
                </p>
            </div>
        </section>
    </>
  );
};

export default PrivacyPolicy;
